import { globalCss } from 'srs.sharedcomponents/lib/esm/styles'

export const globalStyles = globalCss({
  '.MuiTable-root, .MuiTableCell-root, p,span': {
    fontFamily: 'FordF1-Regular !important',
  },
})
